<div class="calendar-container">
  <div class="row gutters align-top nowrap-md">
    <div class="col-md-10" >
      <full-calendar [options]="_calendarOptions" [events]="events$ | async" #calendar></full-calendar>
    </div>
    <div class="col-md-2">
      <mat-card appearance="outlined" class="bg-cool-gray-6 legend-box">
        <mat-card-title class="legend-header">
          Legend
          @if (
            blockedResults &&
            blockedResults.me &&
            blockedResults.me.permissionsForResource._edit &&
            !blockDatesActivate
            ) {
            <button
              mat-flat-button
              color="warn"
              class="blocked-button"
              matTooltip="Enable/Disable blocking committee dates"
              matTooltipPosition="left"
              (click)="toggleBlockDatesActivate()"
              >
              <div class="inside-blocked-button">
                <mat-icon>do_not_disturb_alt</mat-icon>
                <mat-icon>calendar_month</mat-icon>
              </div>
            </button>
          }
          @if (
            blockedResults &&
            blockedResults.me &&
            blockedResults.me.permissionsForResource._edit &&
            blockDatesActivate
            ) {
            <button
              mat-flat-button
              color="basic"
              class="blocked-button enabled"
              matTooltip="Enable/Disable blocking committee dates"
              matTooltipPosition="left"
              (click)="toggleBlockDatesActivate()"
              >
              <div class="inside-blocked-button">
                <mat-icon>do_not_disturb_alt</mat-icon>
                <mat-icon>calendar_month</mat-icon>
              </div>
            </button>
          }
        </mat-card-title>
        <mat-card-content>
          <ul class="legend-toggles">
            <li>
              <mat-checkbox style="margin-left: -16px; margin-bottom: -10px;"
                            class="checkbox-cool-gray-3"
                            [checked]="eventManagerService.showOnlyUserDeals"
                            [autofocus]="false"
                            (click)="toggleUserDeals()"
                            matTooltip="Show only projects you are assigned to"
                            matTooltipPosition="left"
                            name="userOnlyProjects"
              >
                <span class="legend-labels">My Deals</span>
              </mat-checkbox>
            </li>
          </ul>
        </mat-card-content>
        <mat-card-content>
          <ul class="legend-toggles">
            @for (type of eventManagerService.typesList(); track type) {
              <li>
                <mat-checkbox style="margin-left: -16px; margin-bottom: -10px;"
                  [class]="[eventManagerService.getColorClass(type)]"
                  [(ngModel)]="eventManagerService.eventTypes[type].checked"
                  [checked]="eventManagerService.eventTypes[type].checked"
                  [autofocus]="false"
                  (click)="toggleGroup(type)"
                  name="{{type + 'legendcheck'}}"
                  >
                  <span class="legend-labels">{{ eventManagerService.eventTypes[type].label }}</span>
                </mat-checkbox>
              </li>
            }
          </ul>
          <mat-divider></mat-divider>
          <ul class="legend-icons">
            <li>
              <mat-icon
                class="txt-red"
                aria-hidden="false"
                #tooltip="matTooltip"
                matTooltip="Earliest Ready Date is 2+ weeks later than Target Date"
                matTooltipPosition="left"
                >warning</mat-icon
                ><span>Target Date Conflict (>=14 days)</span>
              </li>
              <li>
                <mat-icon
                  class="txt-amber"
                  #tooltip="matTooltip"
                  matTooltip="Earliest Ready Date differs from Target Date"
                  matTooltipPosition="left"
                  >warning</mat-icon
                  ><span>Target Date Discrepancy (<14 days)</span>
                </li>
              </ul>
              <mat-divider></mat-divider>
              <em class="legend-explainer"
                >Grayed out dates are blocked from committee scheduling.</em
                >
              </mat-card-content>
            </mat-card>
          </div>
        </div>
      </div>
